module.exports = __webpack_public_path__ + "img/list_view.2d7ed453.svg";